import { useAsyncAbortable } from 'react-async-hook';
import { api } from './instance';

async function fetchAddressDetails(abortSignal, id) {
  if (id) {
    const data = await api.auth.get(`address/${id}`, { signal: abortSignal }).json();
    const building = [];
    for (let i = 1; i <= 3; i++) {
      const line = data[`postal_line_${i}`];
      if (!line || line.includes(data.street)) {
        break;
      }
      building.push(line);
    }
    data.building = building.join(', ');
    return data;
  } else {
    return { success: false };
  }
}

export function useAddress(id, options) {
  return useAsyncAbortable(fetchAddressDetails, [id], options);
}
